import { render, staticRenderFns } from "./AvailabilityBadge.vue?vue&type=template&id=c285524c"
import script from "./AvailabilityBadge.vue?vue&type=script&lang=js"
export * from "./AvailabilityBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports